import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { WarningIcon } from 'partner360/components/QBR/shared/warningIcon/WarningIcon'

import { TRANSLATION_KEYS } from '../../../../../../../../translations'

import styles from './UnsavedChanges.module.scss'

export const UnsavedChanges: FC = () => {
  return (
    <div className={styles.root}>
      <WarningIcon />
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          <Translation text={TRANSLATION_KEYS.unsavedChangesBlock.title} />
        </div>
        <div className={styles.subHeader}>
          <Translation text={TRANSLATION_KEYS.unsavedChangesBlock.subTitle} />
        </div>
      </div>
    </div>
  )
}
